var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "modal-close-btn-point" }, [
      _c(
        "div",
        {
          staticClass: "modal-close-btn-container",
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [_c("SVGModalClose")],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-title-big" }, [
      _vm._v("\n            Уникальный идентификатор (UUID):\n        ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-borderline no-margin-top" }),
    _vm._v(" "),
    _c("div", { staticClass: "modal-uuid-grid ap-modal-element" }, [
      _c("div", { attrs: { id: "data-uuid" } }, [_vm._v(_vm._s(_vm.uuid))])
    ]),
    _vm._v(" "),
    _c("br")
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }